const Backbone = require('backbone');
const AddToCartView = require('views/store/pages/products/addtocart');
const OptionGroupsView = require('views/store/pages/products/optiongroups');
const RecommendedOptionView = require('views/store/pages/products/recommendedoption');
const RecommendedOptionsCollection = require('collections/product/recommendedoptions');
const _renderRecommendedOptionDescription = function(collection) {
	collection.each((option) => {
		this.childViews.recommendedOptions.forEach((optionView) => {
			var finish = optionView.model.getFinishByUniqueId(option.get('uniqueId'));
			if (finish !== undefined) {
				finish.set('description', option.get('description'));
				if (finish.get('selected')) {
					optionView.render();
				}
			}
		});
	});
	$('#modal-product-options')
		.find('.modal-content')
		.trigger('content:updated');
};

var ConfigView = Backbone.View.extend({
	el: '#configure-pricedoptions-recommendedoptions',

	initialize: function(options) {
		var self = this,
			$configurePageContainer = $('#configure-page');

		/**
		 * Product - Reference to parentView model
		 * @type {Object}
		 */
		self.Product = options.parentView.model;
		/**
		 * parentView - Reference to parent view
		 */
		self.parentView = options.parentView;

		/**
		 * If this product has Priced Options
		 *   Loop through the Priced Option Groups and create new OptionGroup Views
		 */

		self.childViews.optionGroups = [];
		if (self.Product.hasPricedOptions()) {
			self.Product.optionGroups.models.forEach((model) => {
				self.childViews.optionGroups.push(
					new OptionGroupsView({
						model: model,
						el: `#group-${model.get('identity')}`
					})
				);
			});
		}

		self.childViews.recommendedOptions = [];
		if (self.Product.hasRecommendedOption()) {
			self.Product.recommendedOptions.models.forEach((model) => {
				model.set('mainProductSelectedFinish', self.Product.get('selectedFinish').finish);
				self.childViews.recommendedOptions.push(
					new RecommendedOptionView({
						model: model,
						el: $(`#${model.get('dasherizedName')}`),
						parentView: self
					})
				);
			});
		}
		self.childViews.addToCart = new AddToCartView({
			purchaseView: self.parentView.childViews.purchase,
			model: self.parentView.model,
			el:
				window.BCOM.device.isDesktop && window.dataLayer.pageName.indexOf('product-configure') === -1
					? $('#configure-pricedoptions-recommendedoptions').find('#configure-product-wrap,#add-to-cart-wrap')
					: $('#modal-add-to-cart')
		});

		if (!self.Product.hasPricedOptions()) {
			$('#recommended-options').removeClass('hidden');
			$('.product-configuration-footer-content').addClass('hidden');
			$('.recommended-option-buttons').removeClass('hidden');
			$('#modal-add-to-cart').removeClass('narrow-configure-footer-display');
			$('.add-to-cart-wrap').removeClass('configure-is-active');
			$configurePageContainer.addClass('configured');
		}
	},

	fetchRecommendedOptionDescriptions: function() {
		if (!this.recommendedOptions) {
			this.recommendedOptions = new RecommendedOptionsCollection();
			this.recommendedOptions.uniqueId = window.BCOM.data.uniqueIds
				? window.BCOM.data.uniqueIds[0]
				: window.dataLayer.selectedFinish.uniqueId;
			this.recommendedOptions.fetch({
				success: _renderRecommendedOptionDescription.bind(this)
			});
		}
	}
});

module.exports = ConfigView;
